var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('EmpathyX',{class:{'ebx-empathy-x--is-blog' : _vm.isBlog }})}
var staticRenderFns = []

export { render, staticRenderFns }